export class MonthlyTabulationList {
    public workingYm: string
    public empTypeNm: string
    public empCd: string
    public empNm: string
    public status: string
    public divisionNm: string
    public daycntDefault: string
    public daycntTotal: string
    public daycntHoliday: string
    public daycntCanExchange: string
    public daycntPaidVacation: string
    public daycntExchange: string
    public daycntSpecialHoliday: string
    public daycntAdsence: string
    public lateTime: string
    public lateCnt: string
    public earlyTime: string
    public earlyCnt: string
    public wktimeActual: string
    public overA: string
    public overB: string
    public houA: string
}
